import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const NotificationSettings = () => {
  const routes = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Notification Settings</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Admin</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Notification Settings
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="pe-1 mb-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
              >
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                >
                  <i className="ti ti-refresh" />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="pe-1 mb-2">
              <button className="btn btn-primary">
                <i className="ti ti-device-floppy me-2"></i>
                Save Settings
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          {/* System Notifications */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">System Notifications</h4>
              </div>
              <div className="card-body">
                <div className="notification-settings">
                  {/* User Registration */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>New User Registration</h6>
                      <p className="text-muted">Get notified when new users register in the system</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="userRegistration"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* Document Requests */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Document Requests</h6>
                      <p className="text-muted">Receive alerts for new document requests requiring review</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="documentRequests"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* System Errors */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>System Errors & Alerts</h6>
                      <p className="text-muted">Critical system errors and security alerts</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="systemErrors"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* User Activities */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                    <div className="mb-3">
                      <h6>User Activity Summary</h6>
                      <p className="text-muted">Daily/weekly summary of user activities</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="userActivity"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Email Notifications */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Email Notifications</h4>
              </div>
              <div className="card-body">
                <div className="notification-settings">
                  {/* Email Reports */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Daily Reports</h6>
                      <p className="text-muted">Receive daily system activity reports via email</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="dailyReports"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* Security Alerts */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Security Alerts</h6>
                      <p className="text-muted">Immediate email alerts for security issues</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="securityAlerts"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* Backup Status */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Backup Status</h6>
                      <p className="text-muted">Notifications about system backup status</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="backupStatus"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* Maintenance */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                    <div className="mb-3">
                      <h6>Maintenance Windows</h6>
                      <p className="text-muted">Scheduled maintenance and downtime alerts</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="maintenance"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Notification Frequency */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Notification Frequency</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Email Digest Frequency</label>
                  <select className="form-select">
                    <option>Real-time (Immediate)</option>
                    <option>Hourly</option>
                    <option selected>Daily</option>
                    <option>Weekly</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Alert Priority Threshold</label>
                  <select className="form-select">
                    <option>All notifications</option>
                    <option>Medium priority and above</option>
                    <option selected>High priority only</option>
                    <option>Critical only</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Quiet Hours</label>
                  <div className="row">
                    <div className="col-6">
                      <input type="time" className="form-control" defaultValue="22:00" />
                      <small className="text-muted">Start time</small>
                    </div>
                    <div className="col-6">
                      <input type="time" className="form-control" defaultValue="08:00" />
                      <small className="text-muted">End time</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Notification Channels */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Notification Channels</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <h6>Primary Admin Email</h6>
                  <input
                    type="email"
                    className="form-control"
                    defaultValue="admin@school.edu"
                    placeholder="Enter primary email"
                  />
                  <small className="text-muted">Main recipient for all critical notifications</small>
                </div>
                
                <div className="mb-3">
                  <h6>Secondary Emails</h6>
                  <div className="input-group mb-2">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="supervisor@school.edu"
                    />
                    <button className="btn btn-outline-primary" type="button">
                      <i className="ti ti-plus"></i>
                    </button>
                  </div>
                  <small className="text-muted">Additional recipients for important alerts</small>
                </div>

                <div className="mb-3">
                  <h6>SMS Notifications</h6>
                  <div className="input-group">
                    <span className="input-group-text">+1</span>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="(555) 123-4567"
                    />
                  </div>
                  <small className="text-muted">For urgent security alerts only</small>
                </div>

                {/* TODO: Integrate with SMS API */}
                {/* TODO: Add webhook support for third-party integrations */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
